import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.2626 2.17675C17.946 1.49333 19.054 1.49333 19.7375 2.17675L22.3232 4.76254C23.0067 5.44595 23.0067 6.55399 22.3232 7.23741L19.5303 10.0303L19.5179 10.0425L8.68981 20.3784C8.49198 20.5672 8.25264 20.7071 7.99101 20.7867L2.46839 22.4675C2.20341 22.5481 1.91555 22.4762 1.71969 22.2803C1.52383 22.0844 1.45187 21.7966 1.53251 21.5316L3.20612 16.0326C3.29376 15.7446 3.45421 15.4841 3.67196 15.2763L14.4759 4.96347L17.2626 2.17675ZM14.9878 6.54844L4.70768 16.3613C4.67657 16.391 4.65365 16.4282 4.64113 16.4694L3.37697 20.623L7.55426 19.3517C7.59164 19.3403 7.62583 19.3203 7.65409 19.2933L17.9269 9.48749L14.9878 6.54844ZM19 8.43931L21.2626 6.17675C21.3602 6.07912 21.3602 5.92083 21.2626 5.8232L18.6768 3.23741C18.5792 3.13978 18.4209 3.13978 18.3232 3.23741L16.0607 5.49997L19 8.43931Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgPencil;
